"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SIGN_FORMATS = ['.pdf', '.docx', '.doc'];
exports.SIGNATURE_OR_STAMP_FORMATS = ['.jpg', '.jpeg', '.png'];
exports.DOCUMENT_OCR_FORMATS = ['.pdf', '.png', '.jpg', '.jpeg', '.tiff', '.tif'];
exports.DOCUMENT_FORMATS = ['.pdf', '.docx', '.doc', '.xls', '.xlsx', '.txt'];
exports.VIDEO_FORMATS = ['.wma', '.wmf', '.avi', '.asf', '.mov', '.flv', '.mpg', '.mp4', '.wmv', '.h264', '.divx', '.webm'];
exports.VIDEO_DISPLAYABLE_FORMATS = ['.mp4', '.mov', '.webm'];
exports.AUDIO_FORMATS = ['.mp3'];
exports.IMAGE_FORMATS = ['.bmp', '.gif', '.jpg', '.jpeg', '.jpg', '.pbm', '.pct', '.png', '.ppm', '.psd', '.tif', '.tiff'];
exports.DOCUMENT_EDITABLE_FORMATS = ['.docx', '.doc'];
exports.TIFF_FORMATS = ['.tif', '.tiff'];
exports.isTiff = function (format) {
    return exports.TIFF_FORMATS.includes(format);
};
exports.isDocument = function (format) {
    return exports.DOCUMENT_FORMATS.includes(format);
};
exports.isEditable = function (format) {
    return exports.DOCUMENT_EDITABLE_FORMATS.includes(format);
};
exports.isDisplayableVideo = function (format) {
    return exports.VIDEO_DISPLAYABLE_FORMATS.includes(format);
};
exports.isOCRFile = function (format) {
    return exports.DOCUMENT_OCR_FORMATS.includes(format);
};
exports.isAudio = function (format) {
    return exports.AUDIO_FORMATS.includes(format);
};
exports.isVideo = function (format) {
    return exports.VIDEO_FORMATS.includes(format);
};
exports.isImage = function (format) {
    return exports.IMAGE_FORMATS.includes(format);
};
exports.isSignable = function (format) {
    return exports.SIGN_FORMATS.includes(format);
};
exports.isSignatureOrStampFile = function (format) {
    return exports.SIGNATURE_OR_STAMP_FORMATS.includes(format);
};
exports.getNewVersionedFileName = function (fileName, isConfirmed) {
    var fileNameWithoutExtension = fileName.split('.').slice(0, -1).join('.');
    var matches = fileNameWithoutExtension['matchAll'](/(.+)_v(\d+)$/g).next().value;
    if (matches && matches.length) {
        var fileNameWithoutVersion = matches[1];
        var currentVersion = +matches[2];
        if (isConfirmed) {
            var newVersion = currentVersion + 1;
            return fileNameWithoutVersion + "_v" + newVersion;
        }
        else {
            return fileNameWithoutExtension;
        }
    }
    return fileNameWithoutExtension + "_v1";
};
//# sourceMappingURL=file-utils.js.map